import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import CameraAltIcon from "@mui/icons-material/CameraAlt"; // Icon for Social Studio
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { keyframes } from "@mui/system";

const slideInRight = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

function PlatformScoutGuidance() {
    const [visible, setVisible] = useState(false);
    const theme = useTheme();

    // Check demo state
    const isLiveDemo = sessionStorage.getItem('demo_role_cache') === "demo_viewer";

    // We can also check if they've actually performed a search if we set a flag.
    // For now, let's use a timer to simulate "after some activity" or just being on the page for a bit.
    useEffect(() => {
        if (!isLiveDemo) return;

        const checkVisibility = () => {
            const isVisited = sessionStorage.getItem("demo_visited_scout") === "true";
            const alreadyCompleted = sessionStorage.getItem("platform_scout_completed") === "true";

            if (isVisited && !alreadyCompleted) {
                setVisible(true);
            }
        };

        // Check on mount
        checkVisibility();

        // Listen for the "Search" completion event
        const handleEvent = () => {
            setTimeout(checkVisibility, 500);
        };

        window.addEventListener('demoVisitUpdated', handleEvent);
        return () => window.removeEventListener('demoVisitUpdated', handleEvent);
    }, [isLiveDemo]);

    if (!visible) return null;

    const config = {
        title: "Explore Social Studio",
        body: "You've seen how to find competitors. Now, let's create professional reports and snapshots in <b>Social Studio</b>.",
        button: "Go to Social Studio",
        to: "/social-studio",
        icon: <CameraAltIcon />
    };

    return (
        <MDBox
            position="fixed"
            bottom="24px"
            right="24px"
            borderRadius="xl"
            coloredShadow="dark"
            p={3}
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            zIndex={9999}
            sx={{
                maxWidth: "400px",
                border: "2px solid #00A1A1", // Teal border to match SocialPopup
                backgroundColor: theme.functions.rgba("#000", 0.6), // Dark semi-transparent
                backdropFilter: `saturate(200%) blur(30px)`, // Frosted effect
                animation: `${slideInRight} 0.5s ease-out forwards`,
            }}
        >

            <MDBox display="flex" alignItems="center" gap={1.5} mb={2}>
                <TipsAndUpdatesIcon sx={{ color: "#FFB347" }} />
                <MDTypography variant="h6" fontWeight="bold" color="white">
                    {config.title}
                </MDTypography>
            </MDBox>

            <MDTypography variant="body2" color="white" opacity={0.8} mb={3}>
                <span dangerouslySetInnerHTML={{ __html: config.body }} />
            </MDTypography>

            <MDButton
                component={Link}
                to={config.to}
                variant="gradient"
                color="accent"
                fullWidth
                startIcon={config.icon}
                onClick={() => {
                    // Optional: Track that they moved to Social Studio
                    sessionStorage.setItem("platform_scout_completed", "true");
                }}
                sx={{
                    fontWeight: "bold",
                    boxShadow: "0 0 15px rgba(255, 179, 71, 0.4)"
                }}
            >
                {config.button}
            </MDButton>
        </MDBox>
    );
}

export default PlatformScoutGuidance;
